module.exports = __webpack_public_path__ + "static/media/election.8723d460.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/election.svg
// module id = 373
// module chunks = 7